import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import IMAGES from '../../images'
import {
  CashFlowItem,
  CashFlowItemDescription,
  CashFlowItemList,
  CashFlowItemTitle,
  CashFlowWrapper,
} from './CashFlowStyled'
import { ButtonGradient, ButtonGradientWrapper, CircleBackground } from '../CommonStyled/CommonStyled'
import config from '../../config'
import { PAGES, REGISTER_ID, VIEW_MODE } from '../../constant'
import DangerouslySetInnerHtml from '../DangerouslySetInnerHtml'
import { buildPath } from '../../utils/common'

const CashFlow = props => {
  const { cashData, mode } = props
  const handleClickRegister = () => {
    switch (mode) {
      case VIEW_MODE.PREVIEW:
        window.open(`${config.basePath}${PAGES.REGISTER_PREVIEW_SME.PATH}/${REGISTER_ID.CASH_FLOW}`, '_blank')
        break
      case VIEW_MODE.PUBLIC:
        window.open(`${config.basePath}${PAGES.REGISTER_SME.PATH}/${REGISTER_ID.CASH_FLOW}`, '_blank')
        break
      default:
        break
    }
  }

  return (
    <CashFlowWrapper>
      <CircleBackground padding={'0 0 16px 0'}>
        <CashFlowItemList>
          <CashFlowItem>
            {cashData?.featureInformation?.image1 && (
              <img src={buildPath(cashData?.featureInformation?.image1)} alt={'1'} width={'100%'} />
            )}
            <CashFlowItemTitle>
              <DangerouslySetInnerHtml html={cashData?.featureInformation?.description1} />
            </CashFlowItemTitle>
          </CashFlowItem>
          <CashFlowItem>
            {cashData?.featureInformation?.image2 && (
              <img src={buildPath(cashData?.featureInformation?.image2)} alt={'2'} width={'100%'} />
            )}
            <CashFlowItemTitle>
              <DangerouslySetInnerHtml html={cashData?.featureInformation?.description2} />
            </CashFlowItemTitle>
          </CashFlowItem>
          <CashFlowItem>
            {cashData?.featureInformation?.image3 && (
              <img src={buildPath(cashData?.featureInformation?.image3)} alt={'3'} width={'100%'} />
            )}
            <CashFlowItemTitle>
              <DangerouslySetInnerHtml html={cashData?.featureInformation?.description3} />
            </CashFlowItemTitle>
          </CashFlowItem>
          <CashFlowItem>
            {cashData?.featureInformation?.image4 && (
              <img src={buildPath(cashData?.featureInformation?.image4)} alt={'4'} width={'100%'} />
            )}
            <CashFlowItemTitle>
              <DangerouslySetInnerHtml html={cashData?.featureInformation?.description4} />
            </CashFlowItemTitle>
          </CashFlowItem>
        </CashFlowItemList>
        {cashData?.registerButton?.show && (
          <ButtonGradientWrapper margin={'24px 0 0 0'}>
            <ButtonGradient onClick={handleClickRegister}>{cashData?.registerButton?.buttonText}</ButtonGradient>
          </ButtonGradientWrapper>
        )}
      </CircleBackground>
    </CashFlowWrapper>
  )
}

CashFlow.propTypes = {
  cashData: PropTypes.object,
}

export default CashFlow
